<template>
  <div class="container-box">
    <div class="container-inner">
      <h2 class="title-type-1">
        캠페인 수정
        <span class="attention-coment-1">
          <v-icon>mdi-alert-circle</v-icon>
          캠페인 수정 후 저장버튼을 클릭하여야 변경 정보가 저장됩니다.
        </span>
      </h2>
      <ul class="tab-type-1">
        <li>
          <a href="/campaign" class="active">캠페인 정보</a>
        </li>
        <li>
          <a href="javascript:void(0);" @click.stop="goInveontoryAddPage"
            >캠페인 광고상품 관리</a
          >
        </li>
      </ul>

      <v-form ref="form" refs="form">
        <!-- campaignName -->
        <h3 class="title-type-3">
          캠페인명
          <p class="form-coment-1 ml-2 mt-1">
            <v-icon>mdi-alert-circle-outline</v-icon>
            캠페인 시작 후 캠페인명은 변경이 불가합니다.
          </p>
        </h3>
        <div class="relative white rounded pa-6 mb-8 text-md-body-1">
          {{ campaignName }}
        </div>
        <!--// campaignName -->
        <!-- campaign date range -->
        <h3 class="title-type-3">
          캠페인 기간
          <span class="required">
            <v-icon>mdi-check-circle-outline</v-icon>
            필수
          </span>
        </h3>
        <div class="relative white rounded pa-6 mb-8 d-flex align-center">
          <div class="datepicker-type-1">
            <v-icon>mdi-calendar-blank</v-icon>
            <date-range-picker
              v-model="dateRange"
              :locale-data="localeData"
              :ranges="false"
              :time-picker="true"
              :time-picker-seconds="true"
              :time-picker-increment="1"
              opens="right"
              @update="updateDateRange(dateRange)"
            ></date-range-picker>
          </div>
        </div>
        <!-- //campaign date range -->

        <div class="form-wrap">
          <!-- advertiser select -->
          <div class="form-group mb-8">
            <h3 class="title-type-3">
              광고주
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6">
              <div class="search-1">
                <span class="readinput" style="width: 350px">
                  <v-text-field
                    class="input-custom-2"
                    height="40px"
                    min-width="300px"
                    v-model="advertiserName"
                    hide-details
                    solo
                    readonly
                    @click.stop="openAdvertiserPopup"
                  ></v-text-field>
                </span>
                <v-btn
                  depressed
                  large
                  max-height="40px"
                  color="#fecd06"
                  class="button-type-1 ml-2"
                  @click.stop="openAdvertiserPopup"
                >
                  찾기
                </v-btn>
                <v-btn
                  depressed
                  large
                  max-height="40px"
                  color="#fff"
                  class="button-type-1 ml-2"
                  @click.stop="adviertierCancel"
                >
                  취소
                </v-btn>
              </div>
            </div>
          </div>
          <!-- advertiser select -->
          <!-- agency select -->
          <div class="form-group mb-8">
            <h3 class="title-type-3">대행사</h3>
            <div class="d-flex white rounded pa-6">
              <div class="search-1">
                <span class="readinput" style="width: 350px">
                  <v-text-field
                    class="input-custom-2"
                    height="40px"
                    min-width="300px"
                    v-model="agencyName"
                    hide-details
                    solo
                    readonly
                    @click.prevent="openAgencyPopup"
                  ></v-text-field>
                </span>
                <v-btn
                  depressed
                  large
                  max-height="40px"
                  color="#fecd06"
                  class="button-type-1 ml-2"
                  @click.prevent="openAgencyPopup"
                >
                  찾기
                </v-btn>
                <v-btn
                  depressed
                  large
                  max-height="40px"
                  color="#fff"
                  class="button-type-1 ml-2"
                  @click.stop="agencyCancel"
                >
                  취소
                </v-btn>
              </div>
            </div>
          </div>
          <!-- agency select -->
        </div>
        <!-- 노출관리 -->
        <h3 class="title-type-3">
          노출관리
          <span class="required">
            <v-icon>mdi-check-circle-outline</v-icon>
            필수
          </span>
        </h3>
        <div class="relative white rounded pa-6 mb-8">
          <v-radio-group v-model="isValid" class="mt-0" row>
            <v-radio
              label="ON"
              value="Y"
              color="#fecd00"
              class="radio-type-1"
            ></v-radio>
            <v-radio
              label="OFF"
              value="N"
              color="#fecd00"
              class="radio-type-1 ml-10"
            ></v-radio>
          </v-radio-group>
        </div>
        <!--// 노출관리 -->

        <!--btn-group-->
        <div class="d-flex justify-end mt-10">
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fff"
            class="button-type-1"
            @click.stop="cancel"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fecd06"
            class="button-type-1 ml-4"
            :disabled="!this.dateRange || !this.advertiserId"
            @click.prevent="updateCampaign"
          >
            완료
          </v-btn>
        </div>
        <!--//btn-group-->
      </v-form>
      <SystemAlert v-model="showSystemAlert">
        <div slot="noti-text" v-html="logResult"></div>
        <div slot="noti-btns">
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fecd06"
            class="button-type-1"
            @click.stop="closePopup"
          >
            확인
          </v-btn>
        </div>
      </SystemAlert>
      <div v-if="this.searchAdveriser">
        <SearchOnlyAdvertiserModal
          v-model="searchAdveriser"
          @select:advertiser="selectAdvertiser"
        />
      </div>
      <div v-if="this.searchAgency">
        <SearchAgencyModal
          v-model="searchAgency"
          @select:advertiser="selectAgency"
        />
      </div>
    </div>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import DateRangePicker from 'vue2-daterange-picker';
import { toISOFormattedDate } from '@/utils/validation';
import { advertiserList } from '@/api/advertiser';
import { updateCampaign, detailCampaign } from '@/api/campaign';
import SystemAlert from '~@/modal/SystemAlert.vue';
import SearchOnlyAdvertiserModal from '~@/modal/SearchOnlyAdvertiserModal';
import SearchAgencyModal from '~@/modal/SearchAgencyModal';

import moment from 'moment';

let defaultStartAt = new Date();
defaultStartAt.setHours(0, 0, 0, 0);
defaultStartAt = moment(defaultStartAt);

let defaultEndAt = new Date();
defaultEndAt.setHours(23, 59, 0, 0);
defaultEndAt = moment(defaultEndAt).add(1, 'months');

export default {
  components: {
    SearchOnlyAdvertiserModal,
    SearchAgencyModal,
    DateRangePicker,
    SystemAlert,
  },
  data: () => ({
    campaignInfo: {},
    campaignName: '',
    dateRange: {
      startDate: defaultStartAt,
      endDate: defaultEndAt,
    },
    localeData: {
      format: `yyyy-mm-dd HH:MM:ss`,
      applyLabel: '확인',
      cancelLabel: '취소',
      separator: '　~　',
    },

    advertiserNames: [],
    searchSelAdvertiser: '',
    advertiserMap: {},

    advertiserName: '',
    advertiserId: '',

    agencyNames: [],
    searchSelAgency: '',
    agencyMap: {},

    agencyName: '',
    agencyId: '',

    isValid: 'Y',

    showSystemAlert: false,
    logResult: '',
    resultType: '',
    campaignId: '',

    searchAdveriser: false,
    searchAgency: false,
  }),
  computed: {},
  methods: {
    async getAdvertiserList() {
      try {
        const { data } = await advertiserList();
        bus.$emit('end:spinner');
        const list = data.list;
        const advertiserMap = {};
        const advertiserNames = [];
        const agencyMap = {};
        const agencyNames = [];
        (list || []).forEach(item => {
          if (item.type === 'advertiser' || item.type === 'internal') {
            advertiserMap[item.name] = item;
            advertiserNames.push(item.name);
          } else if (item.type === 'agency') {
            agencyMap[item.name] = item;
            agencyNames.push(item.name);
          }
          this.advertiserMap = advertiserMap;
          this.advertiserNames = advertiserNames;

          this.agencyMap = agencyMap;
          this.agencyNames = agencyNames;
        });
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    updateDateRange(data) {
      this.$moment(data.startDate).format('YYYY-MM-DD HH:mm:ss');
      this.$moment(data.endDate).format('YYYY-MM-DD HH:mm:ss');
    },
    async getDetailCampaign() {
      const campaignId = this.$route.params.id;
      try {
        const { data } = await detailCampaign(campaignId);
        this.campaignInfo = data.row;
        this.campaignName = data.row.name;

        this.dateRange.startDate = data.row.start_at
          ? data.row.start_at
          : defaultStartAt;

        this.dateRange.endDate = data.row.end_at
          ? data.row.end_at
          : defaultEndAt;

        //this.searchSelAdvertiser = data.row.advertiser.name;

        this.advertiserName = data.row.advertiser.name;
        this.advertiserId = data.row.advertiser.id;

        if (data.row.hasOwnProperty('agency')) {
          this.agencyName = data.row.agency.name;
        }

        this.isValid = data.row.is_valid;
      } catch (error) {
        console.log(error.response);
      }
    },
    async updateCampaign() {
      bus.$emit('start:spinner');

      const campaignId = this.$route.params.id;
      let startDate = toISOFormattedDate(new Date(this.dateRange.startDate));
      let endDate = toISOFormattedDate(new Date(this.dateRange.endDate));

      try {
        const campaignData = {
          start_at: startDate,
          end_at: endDate,
          advertiser: { id: this.advertiserId },
          agency: { id: this.agencyId },
          is_valid: this.isValid,
        };

        const { data } = await updateCampaign(campaignId, campaignData);

        this.resultType = data.result;
        if (data.result === 'success') {
          this.showSystemAlert = true;
          this.logResult = '캠페인이 수정 등록되었습니다!';
          this.campaignId = data.value;
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'DuplicatedEntry') {
          this.showSystemAlert = true;
          this.logResult = `중복된 캠페인명이 있습니다.<br>캠페인명을 변경해주세요.`;
        } else if (data.result === 'IsAlreadyReserved') {
          this.showSystemAlert = true;
          this.logResult = `선택하신 캠페인에 포함된 상품(지면)중 <br>현재 다른 캠페인에서 사용중인 지면이 <br>포함되어 있습니다.<br><br>지면별 일정을 확인 / 수정후<br>다시 시도해주시기 바랍니다.`;
        } else if (data.result === 'OutRange') {
          this.showSystemAlert = true;
          this.logResult = `해당 캠페인에 속해있는 소재와 지면의 기간을 모두 포함해야 합니다.<br><br>기간 확인 후 다시 설정해주세요.`;
        } else {
          this.showSystemAlert = true;
          this.logResult = `수정 중 에러가 발생했습니다. 재시도 부탁드립니다.`;
        }
      }
    },

    closePopup() {
      const type = this.resultType;
      const campaignId = this.$route.params.id;
      if (type === 'success') {
        this.$router
          .push({ path: `/campaign/${campaignId}/modify/inventories_list` })
          .catch(() => {});
      }

      this.showSystemAlert = false;
    },
    cancel() {
      //this.$refs.form.reset();
      //this.$router.push({ name: 'campaign' }).catch(() => {});
      this.$router.go(-1);
    },
    goInveontoryAddPage() {
      const campaignId = this.$route.params.id;
      this.$router
        .push({ path: `/campaign/${campaignId}/modify/inventories_list` })
        .catch(() => {});
    },
    openAdvertiserPopup() {
      this.searchAdveriser = true;
    },
    openAgencyPopup() {
      this.searchAgency = true;
    },
    selectAdvertiser(data) {
      this.advertiserName = data.name;
      this.advertiserId = data.id;
    },
    selectAgency(data) {
      this.agencyName = data.name;
      this.agencyId = data.id;
    },
    adviertierCancel() {
      this.advertiserName = '';
      this.advertiserId = '';
    },
    agencyCancel() {
      this.agencyName = '';
      this.agencyId = '';
    },
  },
  created() {
    bus.$emit('start:spinner');
    this.getAdvertiserList();
    this.getDetailCampaign();
  },
};
</script>

<style lang="scss" scoped></style>
